import shopPattern from '../../../assets/image/shop_pattern_png.png';
import defaultImg from '../../../assets/image/newShop/defaultImg.png';

interface IProps {
  logo?: string;
  cover?: string;
}

const StoreDetailHeader = ({logo, cover}: IProps) => {
  return (
    <div className="w-full h-28 relative mb-6">
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-t from-[#4F7A20] to-[#91E03B]" />
        <img
          src={cover ?? shopPattern}
          className="w-full h-28 object-cover relative object-center"
          alt="shopPattern"
        />
      </div>
      <div className="h-20 w-20 rounded-full overflow-hidden absolute z-10 border-white border-[3px] right-1/2 -translate-y-1/2 translate-x-1/2 p-0">
        {logo ? (
          <img
            src={logo}
            alt="logo"
            className="h-full w-full object-cover bg-white"
          />
        ) : (
          <img
            src={defaultImg}
            alt="logo"
            className="h-full w-full object-cover"
          />
        )}
      </div>
    </div>
  );
};

export default StoreDetailHeader;
